import AxiosInstance from "./axiosInstance";

export const login = async ({ username, password, remember }) => {
  const creds = {
    email: username,
    password: password,
  };

  try {
    const response = await AxiosInstance.post("/login", creds);
    const token = response.data.token;

    if (remember) {
      localStorage.setItem("token", token); // Persist token across sessions
    } else {
      sessionStorage.setItem("token", token); // Token expires with the session
    }
    console.log("Login successful, token stored.");
    return token; // Optional, if you need to return it
  } catch (error) {
    console.error("Error in login request:", error);
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
};
export const getUserStatus = async () => {
  try {
    const response = await AxiosInstance.get("/me");
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error in login request:", error);
    throw error;
  }
};

export const changePassword = (data) => {
  return AxiosInstance.patch(`/me/change-password`, data)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
